<template>
  <default-layout>

    <BreadcrumLayout>
    <div class="flex">
      <a href="#" class="link-color"><U>Planning</U></a>
      <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
</svg>
 <a href="#" class="link-color"><U>Food Orders</U></a></div>
    </BreadcrumLayout>
    <PageTitleLayout>
      <div class="lg:mb-0 mb-4 2xl:w-3/6 xl:w-2/4">
        <h1 class="heading-color  xl:text-2xl text-sm font-bold">Order #009234</h1>
      </div>
      <div class="w-full flex lg:flex-nowrap flex-wrap lg:justify-end items-center">
        
          <button type="button" class="w-full inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase bg-gray-500 text-white  focus:outline-none sm:w-40 mr-4">
              Cancel
            </button>

             <button type="button" class="sm:mt-0 mt-4 inline-flex justify-center rounded-md font-bold px-2 py-3.5 uppercase bg-gray-500 text-white  focus:outline-none sm:w-48 w-full sm:mr-0 mr-4">
              save as draft
            </button>

         <button type="button" class="md:mt-0 mt-4 menu1-background-color text-base  inline-flex justify-center rounded-md font-bold px-4 py-3.5 uppercase button-color text-white  focus:outline-none md:ml-3 sm:ml-0 sm:w-90 mt-3 sm:mr-0 mr-4">
              mark as complete and download
            </button>


     
      
      </div>
    </PageTitleLayout>
   

      <PageTitleLayout>
      <div class="lg:mb-0 mb-4 w-full md:mt-0 mt-6">
        <h1 class="text-base text-gray-500 font-bold">ID 123333</h1>
      </div>
     
    </PageTitleLayout>
   
    

  
            <div class="searching xl:px-10 px-5 md:pt-10 pt-8 w-full">
<header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg">
  
 <h2 class="text-white text-lg font-bold w-11/12">Order For</h2>

  </header>
  </div>

    <TableIndexLayout>
      <div class="-my-2">
        <div class="py-2 align-middle inline-block xl:px-10 px-5 w-full">
          <div class="shadow overflow-x-auto">
            <table class="min-w-full">
              <thead class="header-bg-color">
                <tr>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base-heading font-bold text-black-800 uppercase tracking-wider relative"
                  >
                   selected date(s)
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                   distributor
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                   first date
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                    last date
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                    COMPONENT
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >
                    age group
                  </th>
                  <th
                    scope="col"
                    class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider"
                  >total meals</th>
                </tr>
              </thead>
              <tbody>
                <!-- Odd row -->
                <tr class="bg-white">
                  <td
                    class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color"
                  >
                    
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color"
                  >
                    ULF
                  </td>

                  <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                   2020-11-01
                  </td>

                  <td
                    class="px-6 py-4 whitespace-nowrap text-base font-medium text-color"
                  >
                    2020-11-05
                  </td>

                  <td
                    class="px-6 py-4 whitespace-nowrap text-base font-medium text-color"
                  >
                    K-5
                  </td>

                  <td
                    class="px-6 py-4 whitespace-nowrap text-base font-medium text-color"
                  >
                    956
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold"
                  >
                   
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
      
    </TableIndexLayout>
    
         
     <header class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg sm:mx-10 mx-6 mt-10">
     <h2 class="text-white text-lg font-bold w-11/12">Order List</h2>
   <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white  font-bold" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
</svg>
      <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-white mr-3"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
               
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                />
              </svg>
  </header>

          <div class="flex flex-col mb-6 mx-10">
            <div class="overflow-x-auto">
              <div class="align-middle inline-block min-w-full">
                <div class="shadow overflow-hidden border-b-2 border-gray-200 sm:rounded-lg">
                 <table class="min-w-full">
          <thead class="header-bg-color">
            <tr>
              <th scope="col" class="id_arrow px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider relative">
                Product Name
              </th>
              <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                needed
              </th>
             <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
               on hand
              </th>
              <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                order
              </th>
               <th scope="col" class="px-6 py-3 text-left text-base font-bold text-black-800 uppercase tracking-wider">
                
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Oddd row -->
            <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                   Tyson-Frozen 1/4 Ib Beef Patty
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color td-background-color">
                   100
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                  <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                  100
                </td>
                <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                    
                </td>  
            </tr>

            <tr class="tr-background-color">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                   Land o Lakes-Shredded Cheddar Cheese
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                  10
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                     <input type="text" value="10" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                   10
                </td>
                 <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                    
                </td>  
            </tr>

            <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                  Horizon-Extra Large Eggs
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                   75
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                  <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                    75
                </td>  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                    
                </td>
            </tr>
         <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                  Alta Dena-2% Milk Boxes
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    5
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                  <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                  5
                </td>  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                  
                </td>
            </tr>

             <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                  Zacky-mini Corn Dogs
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                   100
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                 <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                    100
                </td>  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                   
                </td>
            </tr>
           

           
            
             <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
                Motts-10oz Apple Juice Bottles
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    90
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                   <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                  90
                </td>  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                   
                </td>
            </tr>

             <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
               Mrs.T's-Spicy Bloody Mary Mix
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                   5
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                   <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                 5
                </td>  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                  
                </td>
            </tr>



            <tr class="bg-white">
                <td class="px-6 py-4 whitespace-nowrap text-base font-bold underline id-color">
              Living Green-8"Frozen Cheese Pizza
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    85
                </td>

                <td class="px-6 py-4 whitespace-nowrap text-base text-color">
                    <input type="text" value="" class="shadow-sm focus:outline-none block w-20 p-0 px-1 h-9 bg-gray-100 sm:text-sm border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-50 text-center mr-2">
                </td>
              
                <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color">
                   85

                </td>  <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
                   
                </td>
            </tr>






          </tbody>
        </table>
  </div>
              </div>
            </div>
          </div>
        


          
            
 <div class="w-full sm:flex lg:flex-nowrap flex-nowrap lg:justify-end items-center  mb-6  px-10">
        
         <button type="button" class="w-full inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase bg-gray-500 text-white  focus:outline-none sm:w-40 w-full mr-4">
              Cancel
            </button>

             <button type="button" class=" inline-flex justify-center rounded-md font-bold px-2 py-2 uppercase bg-gray-500 text-white  focus:outline-none sm:w-48 w-full sm:mt-0 mt-3">
              save as draft
            </button>

         <button type="button" class="menu1-background-color  inline-flex justify-center rounded-md font-bold px-4 py-2 uppercase button-color text-white  focus:outline-none sm:ml-3 sm:w-90  mt-3 sm:mt-0">
              mark as complete and download
            </button>



     
      
      </div>
    

  </default-layout>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";

export default {
  components: {
    DefaultLayout,
    Welcome,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
  },
};
</script>
<style>
.min-height-third{
 min-height: 400px; 
}

.sm\:text-sm {
    font-size: 0.850rem;
    line-height: 1.25rem;
}

.w-52-rec {
    width: 13.2rem;
}

.input-background{
background-color: #f8f8f8;
}

.text-base-heading{
font-size: 14px;
}

.button-bg-color-wed-menu2-gray{
border: none!important;
min-height: 35px;
min-width: 35px;
}

.menu1-background-color{
background-color:#FAA43D;
}

.button-bg-color-wed-menu2{
  background-color: #38558e;
  border: none!important;
  min-height: 35px;
  min-width: 35px;
}
.menu1-icon-color{
color: #38558e;
}

.id-color-menu-edit{
color: #F7A53A;
}

.bg-button-color{
background-color: #cb0000;
}

.min-w-min-button{
min-height: 26px;
min-width: 53px;

}

.w-150{
width: 150px;
}

.max-w-0-menu1{
max-width: 4rem;
}

.bg-button-color-green{
 background-color: #22af4b;
}

.bg-button-color-gray{
background-color: #636363;
}
.bg-hard-grey{
background-color: #f4f4f4;
}

.font-size-edit {
    font-size: 10.5px;
}
.w-96-edit-recipes{
width: 35rem;
}

.select-menu-height-edit2 {
  height: 2.8rem;
}


@media screen and (min-width: 1500px) {
.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 16px;
    left: 43px;
    padding-left:7px;
    color: #219FD5;
}

.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left:7px;
    position: absolute;
    top: 16px;
    left: 43px;
}
}

@media screen and (max-width: 1499px){
.id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219FD5;
    padding-left: 7px;
    position: absolute;
    top: 28px;
    left: 43px;
}

.id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 28px;
    left: 43px;
    padding-left: 7px;
    color: #219FD5;
}



}

</style>
